import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { Store } from '@ngrx/store';
import { OrdersActions, selectLoading, selectOrder } from '@us/web/orders/data-access';
import { Order } from '@us/web/shared/data-access';
import { distinctUntilChanged, EMPTY, filter, map, Observable, switchMap, take, tap } from 'rxjs';
import { OrderStatusComponent } from '../../components/order-status/order-status.component';
import { AsyncPipe, JsonPipe, NgIf } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RouterUtil, RouteUtil } from '@us/web/shared/utils';
import { tuiIsPresent } from '@taiga-ui/cdk';
import { RouteService } from '@us/web/shops/feature';
import { BreadcrumbsComponent } from '@us/web/shared/ui';
import { LetDirective } from '@ngrx/component';

@Component({
    selector: 'us-order-detail-status',
    standalone: true,
    imports: [
        OrderStatusComponent,
        AsyncPipe,
        NgIf,
        TranslocoModule,
        IonicModule,
        JsonPipe,
        BreadcrumbsComponent,
        LetDirective
    ],
    templateUrl: './order-detail-status.page.html',
    styleUrls: ['./order-detail-status.page.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderDetailStatusPage implements OnInit {
    private readonly route = inject(ActivatedRoute);
    private readonly store = inject(Store);
    protected readonly routeService = inject(RouteService);

    readonly homePageUrl$ = this.routeService.homePageUrl$;

    private readonly orderIdParams$: Observable<string> = this.route.params.pipe(
        map(params => params[RouterUtil.Cog.OrderId]),
        filter(tuiIsPresent),
        distinctUntilChanged()
    );

    readonly order$: Observable<Order | null> = this.orderIdParams$.pipe(
        switchMap(orderId => this.store.select(selectOrder(orderId)))
    );
    readonly loading$: Observable<boolean> = this.store.select(selectLoading);

    readonly RouteUtil = RouteUtil;

    ngOnInit() {
        this.handleRefresh();
    }

    handleRefresh(event: any = null) {
        this.orderIdParams$
            .pipe(
                take(1),
                tap(id => {
                    this.store.dispatch(OrdersActions.loadOrder({ id }));
                }),
                switchMap(() => (event === null ? EMPTY : this.loading$)),
                filter(loading => !loading),
                take(1),
                tap(() => {
                    event.target?.complete();
                })
            )
            .subscribe();
    }
}
